export const flagManagementTranslation = {
  dependencies: {
    dependentEpi: 'cng-flag-management-dependencies-dependent-epi', // Dependent EPI
    dependentTools: 'cng-flag-management-dependencies-dependent-tools', // Dependent Tools
    dependentUserRights: 'cng-flag-management-dependencies-dependent-user-rights', // Dependent User Rights
  },
  fields: {
    code: 'cng-flag-management-field-code', // Code
    countries: 'cng-flag-management-field-countries', // Countries
    geoMarket: 'cng-flag-management-field-geo-market', // Geo Market
    name: 'cng-flag-management-field-name', // Name
    roles: 'cng-flag-management-field-roles', // Roles
    tool: 'cng-flag-management-field-tool', // Tool
    type: 'cng-flag-management-field-type', // Type
    users: 'cng-flag-management-field-users', // Users
  },
  notifications: {
    createError: 'cng-flag-management-notification-create-error', // Failed to create flag record.
    deleteError: 'cng-flag-management-notification-delete-error', // Failed to delete flag record.
    exportError: 'cng-flag-management-notification-export-error', // Failed to export flag records.
    loadError: 'cng-flag-management-notification-load-error', // Failed to load flag management records.
    resolveNameError: 'cng-flag-management-notification-resolve-name-error', // Failed to resolve flag name.
    updateError: 'cng-flag-management-notification-update-error', // Failed to update flag record.
  },
  subjects: {
    contact: 'cng-flag-management-subject-contact', // contact
    contacts: 'cng-flag-management-subject-contacts', // contacts
    partners: 'cng-flag-management-subject-partners', // Partners
    partner: 'cng-flag-management-subject-partner', // partner
    partnersLowercase: 'cng-flag-management-subject-partners-lowercase', // partners
    contactsTitle: 'cng-flag-management-subject-contacts-title', // Contacts
  },
  typeOptions: {
    accreditations: 'cng-flag-management-type-accreditations', // Accreditations
    campaigns: 'cng-flag-management-type-campaigns', // Campaigns
    epiFlag: 'cng-flag-management-type-epi-flag', // EPI Flag
    programs: 'cng-flag-management-type-programs', // Programs
    tool: 'cng-flag-management-type-tool', // Tool
    tools: 'cng-flag-management-type-tools', // Tools
    userRight: 'cng-flag-management-type-user-right', // User Right
    userRights: 'cng-flag-management-type-user-rights', // User Rights
  },
}

export const replaceFlagManagementTranslationParams = (
  value: string,
  params: Record<string, string | number>
) =>
  Object.entries(params).reduce(
    (result, [key, replacement]) => result.replaceAll(key, String(replacement)),
    value
  )
